module.exports = __webpack_public_path__ + "static/img/about.4f6a9f10.png";